module.exports = __webpack_public_path__ + "static/media/ajax-loader.3a91c8a7.gif";